module.exports = __webpack_public_path__ + "static/img/uav-2.cd22ad81.png";